import { render, staticRenderFns } from "./MultimediaDocuments.vue?vue&type=template&id=0cd20280&"
import script from "./MultimediaDocuments.vue?vue&type=script&lang=js&"
export * from "./MultimediaDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports